import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AlarmsNotificationsDrawerModal } from "@src/components/organisms/modals/alarms-notifications-drawer-modal/alarms-notifications-drawer-modal";

export const AlarmsNotificationsDrawer = () => {
  const showModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.alarmsNotificationsDrawerModal.showModal,
  );

  return <>{showModal && <AlarmsNotificationsDrawerModal />}</>;
};
